// #18008 Kostenkennwerte NHK 2010 (Sachwertrichtlinie, Anlage 1) in €/m² BGF je Standardstufe 1–5,
// einschließlich Baunebenkosten von 17 %. Freistehende Zweifamilienhäuser: Korrekturfaktor 1,05.
export const NHK_2010_COSTS: Record<string, [number, number, number, number, number]> = {
    "1.01": [655, 725, 835, 1005, 1260],
    "1.02": [545, 605, 695, 840, 1050],
    "1.03": [705, 785, 900, 1085, 1360],
    "2.01": [615, 685, 785, 945, 1180],
    "2.02": [515, 570, 655, 790, 985],
    "2.03": [665, 735, 845, 1020, 1275],
    "3.01": [575, 640, 735, 885, 1105],
    "3.02": [480, 535, 615, 740, 925],
    "3.03": [620, 690, 795, 955, 1195],
    "1.11": [655, 725, 835, 1005, 1260],
    "1.12": [570, 635, 730, 880, 1100],
    "1.13": [665, 740, 850, 1025, 1285],
    "2.11": [615, 685, 785, 945, 1180],
    "2.12": [535, 595, 685, 825, 1035],
    "2.13": [625, 695, 800, 965, 1205],
    "3.11": [575, 640, 735, 885, 1105],
    "3.12": [505, 560, 640, 775, 965],
    "3.13": [585, 650, 750, 905, 1130],
    "1.21": [790, 875, 1005, 1215, 1515],
    "1.22": [585, 650, 745, 900, 1125],
    "1.23": [920, 1025, 1180, 1420, 1775],
    "2.21": [740, 825, 945, 1140, 1425],
    "2.22": [550, 610, 700, 845, 1055],
    "2.23": [865, 965, 1105, 1335, 1670],
    "3.21": [695, 770, 885, 1065, 1335],
    "3.22": [515, 570, 655, 790, 990],
    "3.23": [810, 900, 1035, 1250, 1560],
    "1.31": [720, 800, 920, 1105, 1385],
    "1.32": [620, 690, 790, 955, 1190],
    "1.33": [785, 870, 1000, 1205, 1510],
    "2.31": [675, 750, 865, 1040, 1300],
    "2.32": [580, 645, 745, 895, 1120],
    "2.33": [735, 820, 940, 1135, 1415],
    "3.31": [635, 705, 810, 975, 1215],
    "3.32": [545, 605, 695, 840, 1050],
    "3.33": [690, 765, 880, 1060, 1325],
};
